var map = {
	"./1.png": 1772,
	"./10.png": 5797,
	"./11.png": 9517,
	"./12.png": 7292,
	"./2.png": 8174,
	"./3.png": 1979,
	"./4.png": 3296,
	"./5.png": 1908,
	"./6.png": 3243,
	"./7.png": 2947,
	"./8.png": 1371,
	"./9.png": 299
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5653;